import script from "./AppVersionOutdatedModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppVersionOutdatedModal.vue?vue&type=script&lang=ts&setup=true"

import "./AppVersionOutdatedModal.vue?vue&type=style&index=0&id=ce3f05f6&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce3f05f6"]])

export default __exports__